import { render, staticRenderFns } from "./CounterForm.vue?vue&type=template&id=3ba8b50a&"
import script from "./CounterForm.vue?vue&type=script&lang=js&"
export * from "./CounterForm.vue?vue&type=script&lang=js&"
import style0 from "./CounterForm.vue?vue&type=style&index=0&id=3ba8b50a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports